import { render, staticRenderFns } from "./newStore.vue?vue&type=template&id=e61b56c2&scoped=true&"
import script from "./newStore.vue?vue&type=script&lang=js&"
export * from "./newStore.vue?vue&type=script&lang=js&"
import style0 from "./newStore.vue?vue&type=style&index=0&id=e61b56c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61b56c2",
  null
  
)

export default component.exports